import React, { useEffect } from 'react'
import { CreditRange } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import Icon, { ICON_SIZE_REGULAR } from '@divvy-web/skylab.icon'
import Tooltip, { TooltipPositions } from '@divvy-web/skylab.tooltip'

import GoodFitQuestionContent from '@sputnik/pages/PreApplicationPages/GoodFitSurveyPage/GoodFitWizardForm/GoodFitQuestionContent'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const CreditRangeQuestion = () => {
  const creditRangeOptions = [
    {
      id: CreditRange.LESS_THAN_640,
      key: CreditRange.LESS_THAN_640,
      label: (
        <FormattedMessage
          defaultMessage='less than 640'
          id='sputnik.CreditRangeQuestion__2fO0/h'
        />
      ),
      value: CreditRange.LESS_THAN_640,
    },
    {
      id: CreditRange.BETWEEN_640_AND_700,
      key: CreditRange.BETWEEN_640_AND_700,
      label: (
        <FormattedMessage
          defaultMessage='640-700'
          id='sputnik.CreditRangeQuestion__Y7MHkB'
        />
      ),
      value: CreditRange.BETWEEN_640_AND_700,
    },
    {
      id: CreditRange.BETWEEN_701_AND_740,
      key: CreditRange.BETWEEN_701_AND_740,
      label: (
        <FormattedMessage
          defaultMessage='701-740'
          id='sputnik.CreditRangeQuestion__Q4GF1x'
        />
      ),
      value: CreditRange.BETWEEN_701_AND_740,
    },
    {
      id: CreditRange.OVER_740,
      key: CreditRange.OVER_740,
      label: (
        <FormattedMessage
          defaultMessage='741+'
          id='sputnik.CreditRangeQuestion__Z/VVTx'
        />
      ),
      value: CreditRange.OVER_740,
    },
    {
      id: CreditRange.UNREPORTED,
      key: CreditRange.UNREPORTED,
      label: (
        <FormattedMessage
          defaultMessage='I don’t know/don’t wish to provide'
          id='sputnik.CreditRangeQuestion__uDtL1m'
        />
      ),
      value: CreditRange.UNREPORTED,
    },
  ]

  const { tracker } = useWebTracking()

  /* tracking start */

  useEffect(() => {
    tracker?.track('se_signup__qualification_check_credit_score__presented')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* tracking end */

  return (
    <GoodFitQuestionContent
      inputName='creditRange'
      options={creditRangeOptions}
      question={
        <>
          <FormattedMessage
            defaultMessage='What’s the estimated credit score of the authorized signer?'
            id='sputnik.CreditRangeQuestion__g7bG6a'
          />
          <Tooltip
            html={
              <FormattedMessage
                defaultMessage='The authorized signer has the power to control, manage, and direct the company—and enter into this agreement.'
                id='sputnik.CreditRangeQuestion__agstka'
              />
            }
            position={TooltipPositions.TOOLTIP_POSITION_RIGHT_START}
          >
            <Icon
              name='info'
              size={ICON_SIZE_REGULAR}
            />
          </Tooltip>
        </>
      }
    />
  )
}

export default CreditRangeQuestion
